import { render } from "./NoVideoTile.vue?vue&type=template&id=c8abbc4c"
import script from "./NoVideoTile.vue?vue&type=script&lang=js"
export * from "./NoVideoTile.vue?vue&type=script&lang=js"

import "./NoVideoTile.vue?vue&type=style&index=0&id=c8abbc4c&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__